import { ConstantRoutes } from "../../../core/constantRoutes";
import AdminUploadConfigMain from "../adminUploadConfigMain/adminUploadConfigMain";

function AdminRemapping() {
    return(<>
        <AdminUploadConfigMain type="remapping" fileName="Remapping.json" 
              label="Remapping" path={ConstantRoutes.adminRemappingSettings}/>
    </>)
}

export default AdminRemapping;